import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const AddEditRoomTypeForm = (strings: any, width = 3): FormModel[] => {
  const isFilter = width === 12;
  return [
    {
      label: strings.roomType_text_type,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: width === 3 ? 'name' : 'roomTypeName',
      validators:
        width === 12
          ? []
          : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: width },
      required: width === 3,
    },
  ];
};
